const common = {
  nav_home: 'Главная',
  nav_about_turkey: 'О Турции',
  nav_turkey_culture: 'Культура в Турции',
  nav_health_institutions: 'Медицинские учреждения',
  nav_agencies: 'Агентства медицинского туризма',
  nav_contact: 'Контакты',

  nav_login: 'Войти',
  nav_register: 'Регистрация',
  nav_user_login: 'Вход для пользователей',
  nav_user_login_desc: 'Доступ к панели участника',
  nav_institution_login: 'Вход для учреждений',
  nav_institution_login_desc: 'Доступ к панели учреждения',
  nav_admin_login: 'Вход администратора',
  nav_admin_login_desc: 'Управление платформой',
  nav_my_panel: 'Моя панель',
  nav_institution_panel: 'Панель учреждения',
  nav_admin_panel: 'Панель администратора',
  nav_user_panel: 'Панель пользователя',
  nav_institution_label: 'Учреждение',
  nav_admin_label: 'Администратор',
  nav_user_label: 'Пользователь',
  nav_logout: 'Выйти',
  nav_warning_title: 'ВАЖНОЕ ПРЕДУПРЕЖДЕНИЕ',
  nav_warning_text: 'Health Travel Türkiye Platform — это цифровая платформа, которая объединяет людей, нуждающихся в медицинских услугах, с медицинскими учреждениями и агентствами медицинского туризма, предлагающими международные медицинские услуги. На этой платформе предоставляются услуги медицинского туризма. Медицинские учреждения сертифицированы и авторизованы компетентными органами соответствующей страны. Эта платформа предназначена только для информационных целей и не содержит медицинских диагнозов, рекомендаций по лечению или медицинских рекомендаций. Оператор платформы не несёт коммерческой или медицинской ответственности. Пожалуйста, обратитесь к врачу-специалисту по вопросам здоровья.',

  footer_description: 'Получите доступ к одобренным медицинским учреждениям, авторизованным Министерством здравоохранения Турции. Восстановите здоровье безопасно и быстро.',
  footer_quick_links: 'Быстрые ссылки',
  footer_for_institutions: 'Для учреждений',
  footer_institution_login: 'Вход для учреждений',
  footer_register: 'Регистрация',
  footer_contact: 'Контакты',
  footer_email_label: 'Эл. почта',
  footer_address_label: 'Адрес',
  footer_address_value: 'Стамбул, Турция',
  footer_rights: 'Все права защищены.',
  footer_privacy: 'Политика конфиденциальности',
  footer_kvkk: 'Текст раскрытия KVKK',
  footer_terms: 'Условия использования',
  footer_powered: 'Powered by Readdy',
  footer_newsletter_title: 'Будьте в курсе',
  footer_newsletter_desc: 'Подпишитесь, чтобы получать последние новости о медицинском туризме в Турции.',
  footer_newsletter_placeholder: 'Ваш адрес эл. почты',
  footer_newsletter_btn: 'Подписаться',
  footer_newsletter_sending: 'Отправка...',
  footer_newsletter_success: 'Спасибо! Вы подписались.',
  footer_newsletter_error: 'Произошла ошибка. Пожалуйста, попробуйте снова.',

  loading: 'Загрузка...',
  search: 'Поиск',
  filter: 'Фильтры',
  clear: 'Очистить',
  clear_all: 'Очистить всё',
  all: 'Все',
  view_all: 'Посмотреть все',
  view_details: 'Подробнее',
  explore: 'Исследовать',
  back: 'Назад',
  save: 'Сохранить',
  cancel: 'Отмена',
  submit: 'Отправить',
  send: 'Отправить',
  sending: 'Отправка...',
  success: 'Успех',
  error: 'Ошибка',
  no_results: 'Результаты не найдены',
  approved: 'Одобрено',
  pro_member: 'PRO',
  doctor_count: '{{count}} врач',
  verified: 'Проверено',
  accreditation: 'Аккредитация',
  official_accreditation: 'Официальная аккредитация и гарантия',
  health_turkey: 'Health Türkiye',
  health_turkey_desc: 'Платформа медицинского туризма',
  ministry_health: 'Министерство здравоохранения Республики Турция',
  ministry_health_desc: 'Одобренное медицинское учреждение',
  ministry_culture: 'Министерство культуры и туризма Республики Турция',
  ministry_culture_desc: 'Сертификат разрешения на медицинский туризм',
  user_type: 'Пользователь',
  institution_type: 'Учреждение',
  admin_type: 'Администратор',

  // Breadcrumb names (Schema.org JSON-LD)
  breadcrumb_home: 'Главная',
  breadcrumb_contact: 'Контакты',
  breadcrumb_institutions: 'Медицинские учреждения',
  breadcrumb_agencies: 'Агентства медицинского туризма',
  breadcrumb_about_turkey: 'О Турции',
  breadcrumb_turkey_culture: 'Культура Турции',
  breadcrumb_kvkk: 'KVKK',
  breadcrumb_privacy: 'Политика конфиденциальности',
  breadcrumb_terms: 'Условия использования',

  // SEO meta — page titles & descriptions
  seo_home_title: 'Health Travel Türkiye - Платформа медицинского туризма в Турции',
  seo_home_desc: 'Откройте для себя аккредитованные медицинские учреждения Турции для иностранных пациентов. Трансплантация волос, стоматология, эстетическая хирургия, ЭКО и многое другое.',
  seo_turkiye_title: 'О Турции - Путеводитель | Health Travel Türkiye',
  seo_turkiye_desc: 'Полный путеводитель по Турции: города, исторические места, природные чудеса и практическая информация для путешественников.',
  seo_kultur_title: 'Культура Турции - Традиции, Кухня и Жизнь | Health Travel Türkiye',
  seo_kultur_desc: 'Откройте богатое культурное наследие Турции: традиции, кухня, фестивали, культура хаммама, шопинг и социальная жизнь.',
  seo_contact_title: 'Контакты - Health Travel Türkiye',
  seo_contact_desc: 'Свяжитесь с Health Travel Türkiye. Обратитесь к нам по вопросам медицинского туризма в Турции.',
  seo_kvkk_title: 'Текст раскрытия KVKK - Защита персональных данных | Health Travel Türkiye',
  seo_kvkk_desc: 'Защита персональных данных и текст раскрытия KVKK для Health Travel Türkiye.',
  seo_privacy_title: 'Политика конфиденциальности - Безопасность данных | Health Travel Türkiye',
  seo_privacy_desc: 'Политика конфиденциальности и принципы безопасности персональных данных Health Travel Türkiye.',
  seo_terms_title: 'Условия использования - Правила платформы | Health Travel Türkiye',
  seo_terms_desc: 'Условия использования и пользовательское соглашение Health Travel Türkiye.',

  seo_institutions_title: 'Медицинские учреждения в Турции | Health Travel Türkiye',
  seo_institutions_desc: 'Сравните одобренные медицинские учреждения Турции. Найдите лучшие клиники для трансплантации волос, стоматологии, эстетической хирургии, ЭКО и многого другого.',
  seo_agencies_title: 'Агентства медицинского туризма | Health Travel Türkiye',
  seo_agencies_desc: 'Найдите агентства медицинского туризма, которые организуют вашу медицинскую поездку, проживание и туристические потребности в Турции.',
  seo_register_title: 'Регистрация - Присоединиться к Health Travel Türkiye',
  seo_register_desc: 'Создайте аккаунт на Health Travel Türkiye. Зарегистрируйтесь как пациент или медицинское учреждение для доступа ко всем функциям.',
};

export default common;
